import { schema } from "normalizr";

const team = new schema.Entity(`teams`);
const arrayOfTeams = [team];

export { team, arrayOfTeams };
